import { login } from './LoginService';

export const loginFormDataInitialState = {
  usernameOrEmail: "",
  password: "",
  profile: {},
  errors: {},
  readOnly: false
}

export const LoginFormDataReducer = (state, action) => {

  if (action.type === 'FIELD_CLEAR') {
    return loginFormDataInitialState;
  }

  if (action.type === 'FORM_SUBMIT') {
    let {formData, successFunction, failureFunction} = action.payload;
      login(formData, successFunction, failureFunction);
    return {
      ...state,
      readOnly: true,
      status: "Loggin in...",
      errors: {}
    }
  }

  if (action.type === 'FORM_SUBMIT_SUCCESS') {
    let newState = {
      ...state,
      profile: action.payload,
      readOnly: false,
      errors: {}
    };

    return newState;
  }

  if (action.type === 'FORM_SUBMIT_FAIL') {
    let newState = {
      ...state,
      readOnly: false,
      errors: action.payload,
      status:""
    };
    return newState;
  }

  //the following is for form edit and hence there should be a payload.
  //otherwise just return state

  if (!action.payload) {
    return state;
  }
  if (action.type === 'FIELD_EDIT') {
    const { name, value } = action.payload;
    let newState = {
      ...state,
      [name]: value

    };
    return newState;
  }
}
